/** @jsx jsx * */
import { css, jsx } from '@emotion/core'
import { InfoIcon } from 'components/InfoIcon'
import { useMemo } from 'react'
import { isEmpty } from 'util/validation/Util'

interface CodigosUtilizadosInfoIconProps {
  cidsConsiderados?: ReadonlyArray<string>
  ciapsConsiderados?: ReadonlyArray<string>
}

export function ListaTematicaCidCiapUtilizadosInfoIcon({
  cidsConsiderados,
  ciapsConsiderados,
}: Readonly<CodigosUtilizadosInfoIconProps>) {
  const tooltip = useMemo(() => buildTooltip(cidsConsiderados, ciapsConsiderados), [
    cidsConsiderados,
    ciapsConsiderados,
  ])

  if (!tooltip) {
    return null
  }

  return <InfoIcon icon='infoCircleFilled' text={tooltip} tooltipStyle={tooltipStyle} />
}

const formatarLista = (codigos?: ReadonlyArray<string>) => (!isEmpty(codigos) ? codigos.join(', ') : '-')

const buildTooltip = (cidsConsiderados?: ReadonlyArray<string>, ciapsConsiderados?: ReadonlyArray<string>) => {
  if (isEmpty(cidsConsiderados) && isEmpty(ciapsConsiderados)) {
    return undefined
  }

  return `CID-10 considerados: ${formatarLista(cidsConsiderados)}
    
    CIAP-2 considerados: ${formatarLista(ciapsConsiderados)}`
}

const tooltipStyle = css`
  max-width: 31rem;
  white-space: pre-line;
`
